import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function WhatWeDo() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center mb-16 ${isVisible ? 'opacity-100 animate-fade-in-up' : 'opacity-0'}`}>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What We Do
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Everstead helps senior living homes run smoother through systems, workflows, documentation, and staff support.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {[
            'Clean, modern workflow automation',
            'Accurate and organized documentation',
            'Strong onboarding and training',
            'Ongoing operational partnership'
          ].map((item, index) => (
            <div 
              key={index}
              className={`flex items-start space-x-4 p-6 bg-gray-50 rounded-xl hover-lift ${
                isVisible ? 'opacity-100 animate-fade-in-left' : 'opacity-0'
              }`}
              style={{ animationDelay: `${index * 0.1 + 0.2}s` }}
            >
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                <i className="ri-check-line text-2xl text-teal-600"></i>
              </div>
              <p className="text-lg text-gray-800 font-medium">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
